<template>
    <section
        :class="[
            `w-[300px] bg-white h-[100vh] flex flex-col relative duration-100 md:flex overflow-y-auto overflow-x-hidden`,
            `z-[1002]`,
            { 'w-[56px] overflow-hidden': isCollapsed },
            { hidden: !isWhiteboard },
        ]"
        :style="
            isWhiteboard
                ? 'box-shadow: 0px 0px 8px 4px rgba(0, 0, 0, 0.15)'
                : ''
        "
        id="app-sidebar"
    >
        <div
            v-if="!defaultCollapsed"
            :class="[
                `absolute right-1 top-6 z-[100] rounded-full w-8 h-8 bg-gray-100 flex items-center justify-center hover:bg-gray-200 cursor-pointer`,
                { 'right-3': isCollapsed },
            ]"
            @click="isCollapsed = !isCollapsed"
        >
            <ion-icon
                v-if="!isCollapsed"
                name="chevron-back-outline"
            ></ion-icon>
            <ion-icon v-else name="chevron-forward-outline"></ion-icon>
        </div>
        <a href="/">
            <img
                v-if="!isCollapsed"
                :src="logo"
                alt="Clipboard Nation Logo"
                class="
                    w-[35%]
                    h-auto
                    mx-auto
                    mt-10
                    border-b-2
                    pb-6
                    border-gray-100
                "
            />
        </a>
        <div v-if="isApp" style="display: contents">
            <a
                onclick="window.NativeApp.backHome()"
                class="mx-auto mt-4"
                v-if="backHref"
            >
                <img
                    src="/default-images/whiteboard/nav-home.svg"
                    alt="Clipboard Nation"
                />
            </a>
            <a
                onclick="window.NativeApp.back()"
                class="mx-auto mt-4"
                v-if="backHref"
            >
                <img src="/default-images/whiteboard/nav-back.svg" alt="Back" />
            </a>
        </div>
        <div v-else style="display: contents">
            <a href="/new-forum" class="mx-auto mt-4" v-if="backHref">
                <img
                    src="/default-images/whiteboard/nav-home.svg"
                    alt="Clipboard Nation"
                />
            </a>
            <a :href="backHref" class="mx-auto mt-4" v-if="backHref">
                <img src="/default-images/whiteboard/nav-back.svg" alt="Back" />
            </a>
        </div>

        <img
            v-if="!backHref && isCollapsed && defaultCollapsed"
            class="w-[65%] mx-auto mt-4"
            alt="Clipboard Nation Small Logo"
            :src="logoSmall"
        />
        <div v-if="!isCollapsed" class="my-10 mx-auto">
            <div class="relative group h-28 mx-auto aspect-square">
                <img
                    :src="avatar"
                    alt="Avatar"
                    class="
                        rounded-full
                        w-full
                        h-full
                        mx-auto
                        border-2 border-solid border-[#049DBF]
                        aspect-square
                        object-cover
                    "
                />
                <a
                    :href="profileHref"
                    class="
                        absolute
                        top-0
                        left-0
                        w-full
                        h-full
                        flex
                        items-center
                        justify-center
                        bg-black bg-opacity-50
                        rounded-full
                        text-white
                        transition-all
                        opacity-0
                        group-hover:opacity-100
                        invisible
                        group-hover:visible
                        cursor-pointer
                        backdrop-blur
                    "
                >
                    Edit
                </a>
            </div>
            <div class="text-center text-lg font-bold mt-4">
                <slot name="name">
                    {{ name }}
                </slot>
            </div>
        </div>
        <div v-if="isCollapsed" class="mt-24"></div>
        <slot class="my-24" :isCollapsed="isCollapsed"></slot>
    </section>
</template>

<script>
export default {
    name: "AppSidebar",
    props: [
        "avatar",
        "name",
        "logo",
        "logoSmall",
        "defaultCollapsed",
        "backHref",
        "profileHref",
        "isWhiteboard",
    ],
    watch: {
        isCollapsed() {
            document.querySelector("#preferences-sidenav-item").style.display =
                this.isCollapsed ? "none" : "block";
            this.$root.sidebarCollapsed = this.isCollapsed;
        },
    },
    mounted() {
        if (window.isApp) {
            this.isApp = true;
        }
        const preferencesSidenaveItem = document.querySelector(
            "#preferences-sidenav-item"
        );
        if (preferencesSidenaveItem) {
            preferencesSidenaveItem.style.display = this.isCollapsed
                ? "none"
                : "block";
        }

        if (window.ReactNativeWebView || window.NativeApp) {
            document.querySelectorAll(".web-only-button").forEach((element) => {
                element.style.display = "none";
            });
        }

        this.$root.sidebarCollapsed = this.isCollapsed;
    },
    data() {
        return {
            isCollapsed: !!this.defaultCollapsed,
            isApp: false,
        };
    },
};
</script>
<style scoped>
.disable-scrollbars::-webkit-scrollbar {
    background: transparent; /* Chrome/Safari/Webkit */
    width: 0px;
}

.disable-scrollbars {
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE 10+ */
}
</style>
